exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.result[data-v-28a47fd1] {\n\tmargin-top: 50px;\n}\n.description-image[data-v-28a47fd1] {\n\tmargin: 0 auto;\n\tmargin-top: 50px;\n\tdisplay: block;\n}\n", ""]);

// exports
